import ManagerRevenue from './ManagerRevenue.container';

export default ManagerRevenue;
